<template>

        <div>
             <!--Retirada a rotina de exclusão da tabela de preço devido a integração e representante-->
            <bar-manut 
                single-entity="Tabela de Preço" 
                plural-entity="Tabela de Preços" 
                :crud="this.crud"
                @closeform="closeForm" 
                @save="handleSave">
            </bar-manut>

            <div class="default-container">
                <div>
                    <div class="row">
                        <form-field ref="descricao" v-model="tabpre.descricao" type="text" col="8" :metadata="metadata.tabpre.descricao" 
                            case="normal" name="descricao" :v-errors="errors" v-validate="metadata.tabpre.descricao.validator"></form-field>
                        <form-field ref="sttabpre" v-model="tabpre.sttabpre" type="select" col="4" :metadata="metadata.tabpre.sttabpre" 
                            name="sttabpre" :v-errors="errors" v-validate="metadata.tabpre.sttabpre.validator"></form-field>
                    </div>
                    <div class="row">
                        <div class="col-md-12 col-12 nb-margin-bottom">
                            <div class="custom-control custom-radio">
                                <input type="radio" id="customRadio1" class="custom-control-input" value="P" v-model="tabpre.tptabela">
                                <label class="custom-control-label data-list" for="customRadio1">Tabela de preços normal com preços informados</label>
                            </div>
                        </div>
                        <div class="col-md-12 col-12 nb-margin-bottom">
                            <div class="custom-control custom-radio">
                                <input type="radio" id="customRadio2" class="custom-control-input" value="A" v-model="tabpre.tptabela">
                                <label class="custom-control-label data-list" for="customRadio2">Tabela automática de acréscimo aplicado na tabela de preços padrão </label>
                            </div>
                        </div>
                        <div class="col-md-12 col-12 nb-margin-bottom">
                            <div class="custom-control custom-radio">
                                <input type="radio" id="customRadio3" class="custom-control-input" value="D" v-model="tabpre.tptabela">
                                <label class="custom-control-label data-list" for="customRadio3">Tabela automática de desconto aplicado na tabela de preços padrão </label>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="tabpre.tptabela != 'P'">
                        <form-field v-model="tabpre.percentual" type="value" col="2" :metadata="metadata.tabpre.percentual" addon="%"
                            name="percentual" :v-errors="errors" v-validate="metadata.tabpre.percentual.validator"></form-field>
                    </div>
                    <div class="row">
                        <form-field v-model="tabpre.texto" case="normal" type="memo" col="8" label="Observações"
                            name="text" :v-errors="errors" v-validate="{}"></form-field>
                    </div>

                </div>
            </div>
</div>

</template>

<script>

import { SysVars } from '../main'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'
import InputTypeahead from '../components/input-typeahead'

export default {
    props: {
        index: '',
        crud: '',
    },

    components: {
        InputTypeahead
    },

    data() {
        return {
            crudText: '',
            tabpre: {...this.$store.getters.getEntities.tabpre},
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
            tabpreit: [],
        }
    },

    computed: {
        editing: function () {
            return this.crud == SysVars.crudU
        }
    },

    watch: {
    },

    methods: {
        closeForm (cod) {
            if (cod) {
               this.$emit('closeform', this.tabpre.codtabpre)
            } else {
               this.$emit('closeform')
            }
        },

        handleSave () {
            //BOTAO SALVAR
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiPost()
                }
            })
        },

        handleDelete () {
            this.apiDelete()
        },

        async loadData () {
            //carrega o registro para alteracao ou visualizacao
            await this.$store.dispatch('loadTabpre', { id: this.index } )
            if (this.$store.getters.getTabpre) {
                this.tabpre = {...this.$store.getters.getTabpre}
            }  
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })

        },

        async apiDelete () {
            //efetua a exclusao
            var modulo = 'cg/tabpre/' + this.tabpre.codtabpre
            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()
            this.closeForm(false)
        },

        async apiPost () {
            //efetua a gravacao
            var modulo = 'cg/tabpre/'
            this.tabpre.tabpreit = this.tabpreit
            var sendData = { tabpre: this.tabpre }

            let update = false
            if (this.crud != SysVars.crudI) {
                update = true
            }

            const data = await apiORDSpost(this.$store, modulo, sendData, 'post')
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if (update) {
                    this.$erpToastUpdated()
                } else {
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.tabpre = data.items[0]
                if (update)
                  this.closeForm(false)
                else
                  this.closeForm(true)
            }
        },

    },

    beforeCreate () {

    },

    created () {
        this.crudText = this.$crudText(this.crud)

        if (this.crud == SysVars.crudI) {
        } else {
            this.loadData()  
        }

        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
            this.$refs.descricao.focus()
        })

    }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/tabpre-form.vue